import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Services: React.FC = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6 }
    }
  };

  const services = [
    {
      id: 1,
      title: 'Consultorias em Visual Merchandising',
      description: 'Consultoria online e presencial in Company com foco em Design de Ambiente e Visual Merchandising.',
      iconText: "🖌️"
    },
    {
      id: 2,
      title: 'Cursos de Visual Merchandising',
      description: 'Capacitação online e presencial in Company para equipes de varejo com foco na organização visual.',
      iconText: "📚"
    },
    {
      id: 3,
      title: 'Design de Interiores',
      description: 'Projetos de revitalização de lojas e espaços comerciais que combinam estética, funcionalidade e bem-estar.',
      iconText: "🏪"
    },
    {
      id: 4,
      title: 'Visual Merchandising',
      description: 'Estratégias para otimizar a experiência de compra e aumentar as vendas no varejo.',
      iconText: "👁️"
    },
    {
      id: 5,
      title: 'Gestão Ambiental',
      description: 'Soluções sustentáveis que integram design e responsabilidade ambiental.',
      iconText: "🌿"
    },
    {
      id: 6,
      title: 'Marketing Estratégico',
      description: 'Consultoria para alinhar design, marca e estratégia de negócios.',
      iconText: "📈"
    }
  ];

  return (
    <section id="services" className="section bg-neutral-light">
      <div className="container">
        <div className="text-center mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl md:text-4xl font-bold text-neutral-dark mb-4"
          >
            Serviço Especializado
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg text-neutral-dark/70 max-w-2xl mx-auto"
          >
            Soluções personalizadas para transformar espaços e impulsionar negócios
          </motion.p>
        </div>

        <motion.div 
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={controls}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {services.map((service) => (
            <motion.div 
              key={service.id}
              variants={itemVariants}
              className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col items-center text-center"
            >
              <div className="mb-2 transform transition-transform duration-300 hover:scale-110 text-4xl">
                {service.iconText}
              </div>
              <h3 className="text-xl font-bold mb-3 text-neutral-dark">{service.title}</h3>
              <p className="text-neutral-dark/70">{service.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Services; 